import * as go from 'gojs';
import { pinPath } from '../assets/pin-shape-path';

export const geometry = () => ({ geometry: go.Geometry.parse(pinPath, true) });
